const COUNTRY_REGION_US = 'US'

export const isUsSupplierTenant = (tenantCountryRegion) =>
  String(tenantCountryRegion || '')
    .trim()
    .toUpperCase() === COUNTRY_REGION_US

export const pickSupplierAmount = ({ tenantCountryRegion, exTax, incTax }) => {
  if (isUsSupplierTenant(tenantCountryRegion)) {
    return exTax ?? incTax ?? 0
  }

  return incTax ?? exTax ?? 0
}

export const pickSupplierCostTotal = ({ tenantCountryRegion, cost }) =>
  pickSupplierAmount({
    tenantCountryRegion,
    exTax: cost?.totalExcludingTax ?? cost?.amountExGst ?? cost?.totalExTax,
    incTax: cost?.totalIncludingTax ?? cost?.amountIncGst ?? cost?.totalIncTax
  })

export const buildSupplierTotalLabel = (tenantCountryRegion, baseLabel) =>
  isUsSupplierTenant(tenantCountryRegion) ? baseLabel : `${baseLabel} (INC TAX)`
